/**
 * @generated SignedSource<<89c8dfa733d59fcb0d263074ca74fba4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShouldShowRecapTab_note$data = {
  readonly hasMeetingRecordings: boolean;
  readonly meetingRecordings: ReadonlyArray<{
    readonly isCurrentlyRecording: boolean | null;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useMeetingRecorderStatus_note">;
  readonly " $fragmentType": "useShouldShowRecapTab_note";
};
export type useShouldShowRecapTab_note$key = {
  readonly " $data"?: useShouldShowRecapTab_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowRecapTab_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldShowRecapTab_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyRecording",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useMeetingRecorderStatus_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "36bc2e0b9082e0b31bf9499fd19c6153";

export default node;
